<template>
    <div class="leaflet-control text-center" style="max-width: 500px;">
      
      <b-button v-if="!visible_legend" @click="visible_legend = !visible_legend" class="m-1" variant="outline-light" style="border-radius: 15px;"><i  class="fa-solid fa-circle-info"></i></b-button>
      <b-button v-if="visible_legend" @click="visible_legend = !visible_legend" class="m-1" variant="outline-danger" style="border-radius: 15px;"><i class="fa-solid fa-xmark"></i></b-button>
        <b-collapse  v-model="visible_legend" class="mt-2" >
          <div class="" style="max-height: 250px;overflow-y: scroll;">
              <div v-for="(kk,indexx) in data" :key="indexx+'legendd'">
              <div class="text-center d-flex justify-content-center"> 
                <strong class="mb-2" style="font-size:16px" v-html="kk.text"></strong>
              </div>
              <div class="">
            
                  <div v-for="(ll,index) in kk.legend" :key="index+'legend'">

                      <div class="d-flex" >
                        <i class="fa-regular fa-square"  :style="{'color':ll,'font-size':'20px','border':'1rem solid;'}" ></i>
                        <p class="px-2" style="font-size: 12px;text-align: left;"> {{ index }}</p>
                      </div>
                      
                  </div>
          
                  
              </div>  
            </div>
        </div>
      </b-collapse>
        
    </div>
</template>


<script>

export default {
  props: {
    data: Array
  },
data(){
    return{
        visible_legend:true,
        legend_data_value:null,
        legend_data_col:null,
        title:null,
    
    }
},
  created(){
    console.log(this.data)
    //this.legend_data_color=this.data.color
    //this.legend_data_value=this.data.value
    //this.title=this.data.title
  }
}

</script>

<style >
.box3 {
    
    padding:8px
    /* height: 22px; */
}
@media screen and (max-width: 730px) {
  .box3 {
    font-size: 14px!important;
    width: 40px;
    /* height: 22px; */
}
}
</style>